/*jslint browser: true, devel: true */
"use strict";

// --------
// Dropzone
// --------

var debug = false;
var thisDropzone;
var maxImageWidth = 10000;
var maxImageHeight = 10000;
var submissionForm = document.forms[0];
var selectButton = document.getElementById("select");
var variablePricing = false;

var progressBarContainer = document.querySelector('.dz-progress-bar-total');
var progressBarText = document.querySelector('.dz-progress-bar-text');
var progressBarTotal = document.querySelector('.dz-progress-bar-total .dz-upload');

// Define the prices array to match the one in your submission.php file
var prices = {
    1: 7.50,
    3: 15.00,
    6: 20.00,
    7: 22.50,
    8: 25.00,
    9: 27.50,
    10: 30.00,
    11: 32.50,
    12: 35.00
};
var totalCost;

Dropzone.options.submission = {
    url: ajax_urls.admin_ajax,
    maxFilesize: 8,
    maxFiles: null,
    acceptedFiles: "image/jpg,image/jpeg,image/png",
    autoProcessQueue: false,
    parallelUploads: 100,
    uploadMultiple: true,
    timeout: (10 * 60 * 1000),
    addRemoveLinks: true,
    clickable: "#add-image",
    thumbnailWidth: null,
    thumbnailHeight: null,
    previewTemplate: document.getElementById("preview-template").innerHTML,
    previewsContainer: document.getElementById("preview-container"),
    dictDefaultMessage: "",
    dictRemoveFile: "Remove",
    dictCancelUpload: "Cancel",
    dictFileTooBig: "Image is too big ({{filesize}}MB), please upload JPEG or PNG Max. 6MB",

    init: function() {
        if (debug) console.log("Dropzone loaded.");

        thisDropzone = this;

        // var buttonClear = document.getElementById("clear");
        var buttonAdd = document.getElementById("add-image");
        var addButtons = document.getElementById("add-buttons");
        var countInfo = document.getElementById("counter-info");
        var elemMessage = document.getElementById("uploader-message");
        var hiddenInput = document.querySelectorAll(".dz-hidden-input")[0];
        var removeImage = document.querySelectorAll(".dz-remove")[0];
        var allAdded = document.querySelectorAll(".dz-clickable")[1];
        var countLeft  = thisDropzone.options.maxFiles - thisDropzone.files.length;
        var totalPrice = document.getElementById("totalprice");

        // Inside the init function of Dropzone options

        // Disable Dropzone functionality initially
        thisDropzone.hiddenFileInput.setAttribute("disabled", "disabled");

        // Update event listener for dropzone clickable area
        var clickableArea = document.querySelector("#add-image");
        var self = this; // Preserve reference to Dropzone instance

        clickableArea.addEventListener("click", function(event) {
            var selectedPrice = document.querySelector('input[name="price"]:checked');

            if (!selectedPrice) {
                event.preventDefault();
                displayMessage({
                    status: "error",
                    message: "Please select a pricing option first."
                });
            } else {
                // Enable Dropzone functionality once a pricing option is selected
                self.hiddenFileInput.removeAttribute("disabled");
                // Process the click event and allow file upload
                self.hiddenFileInput.click();
            }
        });


        // ----------
        // Submission
        // ----------

        selectButton.addEventListener("click", function(event){
            if([1,3,6,7,8,9,10,11,12].includes(thisDropzone.files.length)) {
                thisDropzone.processQueue();
            } else {
                event.preventDefault();
                selectButton.setAttribute("disabled", "disabled");
                displayMessage({
                        status: "error",
                        message: "You can upload 1, 3 or 6 images only."
                        });
            }
        });

        // ------------
        // Clear images
        // ------------

        // buttonClear.addEventListener("click", function(e) {
        //    e.preventDefault();
        //    thisDropzone.removeAllFiles(true);
        // });

        // -------------------
        // Print error message
        // -------------------

        this.on("error", function(event, response) {

            var errorMessage = response.hasOwnProperty("data")
                ? response.data
                : response;

            displayMessage({
                status: "error",
                message: errorMessage
            });
        });

        // ------------------
        // File added handler
        // ------------------

        thisDropzone.on("addedfile", function(file) {
            console.log("File added.");
            // Update total cost display
            updateTotalCost();

            // elemMessage.innerHTML = "&nbsp;";

            // remove file if found to be duplicate
            // SO: http://stackoverflow.com/a/32841273/401980
            if (thisDropzone.files.length) {
                var _i, _len;

                for (
                    _i = 0, _len = thisDropzone.files.length;
                    _i < _len - 1;
                    _i++
                ) {
                    // -1 to exclude current file

                    if (
                        thisDropzone.files[_i].name === file.name &&
                        thisDropzone.files[_i].size === file.size &&
                        thisDropzone.files[_i].lastModifiedDate.toString() ===
                            file.lastModifiedDate.toString()
                    ) {
                        if (debug) console.log("Duplicate detected, removing.");
                        thisDropzone.removeFile(file);

                        displayMessage({
                            status: "error",
                            message: "Image already added."
                        });
                    }
                }
            }

            this.on("thumbnail", function(file) {

                if (file.width > maxImageWidth || file.height > maxImageHeight) {
                    thisDropzone.removeFile(file);
                    displayMessage({
                        status: "error",
                        message: "This image's resolution exceeds the maximum of 10000 pixels."
                    });
                }
            });

            var countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
            var toomuch = thisDropzone.files.length - thisDropzone.options.maxFiles;

            if (variablePricing === false) {
            if (thisDropzone.files.length > thisDropzone.options.maxFiles) {
                if (debug) console.log("Exceeds max file limit, removing.");
                thisDropzone.removeFile(file);

            } else if (thisDropzone.files.length === thisDropzone.options.maxFiles) {
                console.log("File limit reached, enabling submission.");
                addButtons.removeAttribute("hidden");
                selectButton.removeAttribute("disabled");
                document.querySelector(".btn-add-image").classList.add("hidden");
                buttonAdd.hidden = true;
                countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;

            } else if (thisDropzone.files.length < thisDropzone.options.maxFiles) {
                console.log("File added, still below limit.");
                buttonAdd.hidden = true;
                selectButton.setAttribute("disabled", "disabled");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;

                if (countLeft == 1) {
                    countInfo.value = "Please add " + countLeft + " image.";
                }
                if (countLeft != 1) {
                    countInfo.value = "Please add " + countLeft + " images.";
                }
            }
            }
            else if (variablePricing) {
                thisDropzone.options.maxFiles == 12;

                if ( thisDropzone.files.length >= 6 && thisDropzone.files.length != 12) {
                updateTotalCost();
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").removeAttribute("disabled");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                // totalPrice.removeAttribute("hidden");
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                }

                else if ( thisDropzone.files.length === 12) {
                updateTotalCost();
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                document.querySelector(".btn-add-image").classList.add("hidden");
                document.querySelector('.dz-message').style.display = "none";
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                // totalPrice.removeAttribute("hidden");
                }
            };

            // If not logged in
            if (!document.body.classList.contains( 'logged-in' )) {
                console.log("Not logged in.");
                displayMessage({
                        status: "error",
                        message: "Please login or register first."
                        });
            }


            // If we have ANY files, enable the count
            if (thisDropzone.files.length >= 1 ) {
                if (debug) console.log("We have files, enable clear, hide message.");

                addButtons.removeAttribute("hidden");
                document.querySelector('.dz-message').style.display = "none";
            } else if (thisDropzone.files.length <= 0 ) {
                console.log("All images removed");
                addButtons.removeAttribute("hidden");
            }

            // Add caption and title inputs and append them to form
            var caption = file.caption == "undefined" ? "" : file.caption;
            var image_count = thisDropzone.files.length - 1;

            const html = `
                <div class="dz-image-info">
                    <label class="input-wrapper">
                        <input class="input input-small extended" type="text" name="meta[${image_count}][title]" placeholder="Title">
                        <span class="dz-checkmark">✓</span>
                    </label>
                    <label class="input-wrapper">
                        <textarea class="input input-small textarea extended" name="meta[${image_count}][description]" placeholder="Description: tell us about this image (story, location, year)"></textarea>
                        <span class="dz-checkmark">✓</span>
                    </label>
                </div>
            `;

            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = html.trim();
            file._captionBox = tempContainer.firstChild;


            file.previewElement.appendChild(file._captionBox);

            const inputs = file._captionBox.querySelectorAll('input, textarea');
            inputs.forEach(input => {
                const wrapper = input.closest('.input-wrapper');
                input.addEventListener('input', () => {
                    if (input.value.trim() !== '') {
                        wrapper.classList.add('filled');
                    } else {
                        wrapper.classList.remove('filled');
                    }
                });
            });
        });


        this.on('processing', function(progress) {
          progressBarContainer.classList.remove('hidden');
          progressBarContainer.classList.add('processing');
          progressBarText.textContent = progressBarText.dataset.textUploading;
        });

        this.on('success', function(progress) {
          progressBarContainer.classList.remove('processing');
          progressBarContainer.classList.add('success');
          progressBarContainer.classList.remove('error');
          progressBarContainer.classList.remove('hidden');
          progressBarText.textContent = progressBarText.dataset.textProcessing;
        });

        this.on('error', function(progress) {
          progressBarContainer.classList.remove('processing');
          progressBarContainer.classList.add('error');
          if (thisDropzone.files.length == thisDropzone.options.maxFiles) {
                selectButton.removeAttribute("disabled");
            }
          if (thisDropzone.files.length != thisDropzone.options.maxFiles) {
                selectButton.setAttribute("disabled","disabled");
            }  
          setTimeout(func, 5000);
            function func() {
                console.log("Waited 5 seconds.");
                progressBarContainer.classList.add('hidden');
            }
        });

        this.on('totaluploadprogress', function(progress) {
          progressBarTotal.style.width = progress + "%";
          progressBarContainer.classList.add('processing');
          progressBarContainer.classList.remove('error');
        });

        this.on("removedfile", function(file) {
            console.log("File removed, disabling submit.");
            // Update total cost display
            updateTotalCost();
            countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;

            if (variablePricing && thisDropzone.files.length < 6) {
                thisDropzone.options.maxFiles = 6;
                countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
                updateTotalCost();
                if (countLeft == 1) {
                    countInfo.value = "Please add " + countLeft + " image minimum.";
                }
                if (countLeft != 1) {
                    countInfo.value = "Please add " + countLeft + " images minimum.";
                }
                selectButton.setAttribute("disabled","disabled");
                // totalPrice.setAttribute("hidden","hidden");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                document.querySelector(".btn-add-image").removeAttribute("disabled");

            }

            if (variablePricing && thisDropzone.files.length >= 6) { 
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                allAdded.setAttribute("disabled", "");
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").classList.remove("hidden");
                document.querySelector(".btn-add-image").removeAttribute("disabled");
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
            }

            if (variablePricing && thisDropzone.files.length >= 13) { 
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                allAdded.setAttribute("disabled", "");
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").classList.add("hidden");
                document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                countInfo.value = "❌ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
            }

            if (variablePricing == false) {
                if ( thisDropzone.options.maxFiles === 1) {
                    var toomuch = thisDropzone.files.length - 1;
                        if (thisDropzone.files.length < 1) {
                            countInfo.value = "Please add 1 image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (thisDropzone.files.length > 1) {
                            countInfo.value = "Please remove " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (thisDropzone.files.length == 1) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
                if ( thisDropzone.options.maxFiles === 3) {
                    var toomuch = 3 - thisDropzone.files.length;
                        if (toomuch == 1) {
                            countInfo.value = "Please add " + toomuch + " image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft > 1) {
                            countInfo.value = "Please add " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft == 0) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
                if ( thisDropzone.options.maxFiles === 6) {
                    var toomuch = 6 - thisDropzone.files.length;
                        if (toomuch == 1) {
                            countInfo.value = "Please add " + toomuch + " image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft > 1) {
                            countInfo.value = "Please add " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft == 0) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
            }

            // if we don't have any files, disable
            // clearing and show drop message
            if (thisDropzone.files.length < 1) {
                console.log("No more files.");
                countInfo.value = "";
                document.querySelector('.dz-message').style.display = "";
                document.querySelector(".dz-message").removeAttribute("hidden");
            }
        });

        this.on("sendingmultiple", function(files, response) {
            // console.log(response);

            selectButton.classList.add("is-loading");
            selectButton.classList.disabled = true;
        });

        this.on("successmultiple", function(files, response, data) {

            if (response.success) {
                displayMessage({
                    "status": "success",
                    "message": "Your files have been uploaded, you will be redirected shortly."
                });

                window.location.href = "/submissions/" + response.data.redirect_url;
            } else {
                var errorMessage = "It looks like there was an error on our end. If this continues please conact support@independent-photo.com";

                if (
                    response.hasOwnProperty("data") &&
                    response.data.hasOwnProperty("errors") &&
                    Array.isArray(response.data.errors)) {
                        errorMessage = response.data.errors.join("<br>");
                }

                displayMessage({
                    "status": "error",
                    "message": errorMessage
                });
            }
        });
    }
};

document.addEventListener("DOMContentLoaded", function() {
    console.log("Submissions loaded.");
    
    // ------------------------------------------
    // Submission form info toggling (for titles)
    // ------------------------------------------

    submissionForm.addEventListener("change", function(e) {
        var countInfo = document.getElementById("counter-info");
        var radioSelected = document.querySelector('input[name="price"]:checked');
        thisDropzone.options.maxFiles = radioSelected.value;
        updateTotalCost();
        document.getElementById("total-cost").textContent = "$" + totalCost;
        var totalPrice = document.getElementById("totalprice");
        var addButtons = document.getElementById("add-buttons");
        var allAdded = document.querySelectorAll(".dz-clickable")[1];

        if (+e.target.value === 1) {
            thisDropzone.options.maxFiles = 1;
            variablePricing = false;
        }

        if (+e.target.value === 3) {
            thisDropzone.options.maxFiles = 3;
            variablePricing = false;
        }

        if (+e.target.value === 6) {
            thisDropzone.options.maxFiles = 6;
            variablePricing = false;
        }

        var countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
        var toomuch = thisDropzone.files.length - thisDropzone.options.maxFiles;

        if (variablePricing === false) {
        if (thisDropzone.files.length < thisDropzone.options.maxFiles) {
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            if (countLeft == 1) {
                countInfo.value = "Please add " + countLeft + " image.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please add " + countLeft + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length > thisDropzone.options.maxFiles) {
            document.querySelector(".btn-add-image").classList.add("hidden");
            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
            if (toomuch == 1) {
            countInfo.value = "Please remove " + toomuch + " image.";
            }
            if (toomuch > 1) {
            countInfo.value = "Please remove " + toomuch + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length == thisDropzone.options.maxFiles) {
            selectButton.removeAttribute("disabled");
            console.log("Number of images reached.");
            addButtons.removeAttribute("hidden");
            allAdded.setAttribute("disabled", "");
            document.querySelector(".btn-add-image").classList.add("hidden");
            document.querySelector('.dz-message').style.display = "none";
            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
        }
    }

     if (variablePricing === true) {
        if (thisDropzone.files.length < 6) {
            countLeft = 6 - thisDropzone.files.length;
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            if (countLeft == 1) {
                countInfo.value = "Please add " + countLeft + " image minimum.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please add " + countLeft + " images minimum.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length >= 6) {
            selectButton.removeAttribute("disabled");
            console.log("Number of images reached.");
            addButtons.removeAttribute("hidden");
            allAdded.setAttribute("disabled", "");
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            document.querySelector('.dz-message').style.display = "none";
            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / 12";
        }
        if (thisDropzone.files.length >= 13) {
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            countLeft = thisDropzone.files.length - 12;
            if (countLeft == 1) {
                countInfo.value = "Please remove " + countLeft + " image.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please remove " + countLeft + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
     }
    });
});


// ----------------------------------
// remove hidden class from targetted
// element, add it to clicked element
// ----------------------------------

var showButton = document.querySelector(".js-show");

showButton && showButton.addEventListener("click", function(e){
    e.preventDefault();

    var target = document.getElementById(this.getAttribute("data-target"));

    this.classList.add("hidden");
    target.classList.remove("hidden");
    target.focus();
});


// ----------------------------------
// remove hidden class from targetted
// element, add it to clicked element
// ----------------------------------

var voucherButton = document.querySelector(".js-voucher");
var voucherMessage = document.querySelector(".js-voucher-message");



voucherButton && voucherButton.addEventListener("click", function(e){
    e.preventDefault();

    var voucher = submissionForm.voucher.value;
    var email = submissionForm.email.value;
    var givenName = submissionForm.fname.value;
    var surname = submissionForm.lname.value;
    var voucherClass = document.querySelector(".voucherclass");

    var previousPrices = document.querySelectorAll(".previous-price");
    var currentPrices = document.querySelectorAll(".price");
    var applyButton = document.getElementById("applybutton");

    voucherButton.classList.add("is-loading");

    var queryURI = encodeData({
        action: "voucher",
        voucher: voucher,
        email: email,
    });

    var xhr = new XMLHttpRequest();

    xhr.open("POST", ajax_urls.admin_ajax);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    xhr.addEventListener("load", function(){
        if (debug) console.log(xhr);

        console.warn(xhr.responseText)
        var response = JSON.parse(xhr.responseText);

        voucherButton.setAttribute("disabled", true);
        voucherButton.classList.remove("is-loading");

        voucherMessage.innerHTML = response.message;
        voucherMessage.classList.add("is-active");

        setTimeout(function() {
            voucherMessage.classList.remove("is-active");
        }, 5000);

        if (response.status === "success") {
            
            currentPrices.forEach(function(el, index){
    
                var previousPrice = parseInt(el.innerHTML);
    
                previousPrices[index].classList.add("is-visible");
                voucherClass.setAttribute("readonly", true);
                applyButton.innerHTML = "Applied!";
                voucherButton.setAttribute("disabled", true);
    
                animateValue(el, previousPrice, response.prices[index], 500);
            });

        } else {

            voucherButton.disabled = false;
            voucherClass.value = "";

        }

    });

    xhr.send(queryURI);
});


// Function to update total cost display
function updateTotalCost() {
    var countInfo = document.getElementById("counter-info");
    var totalCostElement = document.getElementById("total-cost");

    // Calculate total cost based on the number of images in Dropzone
    var numImages = thisDropzone.files.length;
    var totalCost = prices[numImages] || prices[12]; // Default to max price if not found

    // Update the total cost display in the DOM
    totalCostElement.textContent = "$" + totalCost;
}


function displayMessage(messageObj) {

    var messageElem = document.getElementById("message-box");
    var submitElem = document.getElementById("select");

    submitElem.classList.remove("is-loading");
    submitElem.disabled = false;

    messageElem.classList.remove("success");
    messageElem.classList.remove("error");

    messageElem.classList.add(messageObj.status);
    messageElem.innerHTML = messageObj.message;

    messageElem.classList.add("isActive");

    setTimeout(function() {
        messageElem.classList.remove("isActive");
    }, 8000);
}

// encodes the given object into a usable URI
// with keys and values to be passed via XMLHttpRequest
var encodeData = function(object) {

    return Object.keys(object).map(
        function(k){
            return encodeURIComponent(k) + "=" + encodeURIComponent(object[k])
        }
    ).join("&");
};

function animateValue(el, start, end, duration) {

    // animating equal values kinda breaks this
    if (start == end) return false;

    var range = end - start;
    var current = start;
    var increment = end > start? .5 : -.5;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = el;
    var timer = setInterval(function() {
        current += increment;
        obj.innerHTML = current;
        if (current == end) {
            clearInterval(timer);
        }
    }, 10);
}

function handlePricingSelection(imageFee, priceCount) {
    document.getElementById('pricingoption').value = document.getElementsByClassName('pricingrow')[priceCount].value;
}


